
import { Union, Record } from "../../fable_modules/fable-library-js.5.0.0-alpha.22/Types.js";
import { union_type, decimal_type, record_type, int32_type, string_type } from "../../fable_modules/fable-library-js.5.0.0-alpha.22/Reflection.js";
import { length, item, collect, find, ofArray } from "../../fable_modules/fable-library-js.5.0.0-alpha.22/List.js";
import { singleton, collect as collect_1, delay, toArray } from "../../fable_modules/fable-library-js.5.0.0-alpha.22/Seq.js";
import { rangeDouble } from "../../fable_modules/fable-library-js.5.0.0-alpha.22/Range.js";
import { interpolate, toText, concat, join } from "../../fable_modules/fable-library-js.5.0.0-alpha.22/String.js";
import { map } from "../../fable_modules/fable-library-js.5.0.0-alpha.22/Array.js";
import { int32ToString } from "../../fable_modules/fable-library-js.5.0.0-alpha.22/Util.js";
import { Decimal_Format_32C73145, Decimal_Length_32C73145, Decimal_Normalize_32C73145 } from "../Basics.jsx";
import { equals, fromParts, op_Division, op_Multiply, parse } from "../../fable_modules/fable-library-js.5.0.0-alpha.22/Decimal.js";
import Decimal from "../../fable_modules/fable-library-js.5.0.0-alpha.22/Decimal.js";
import { DecimalInput_Error_6B54009B, DecimalInput__get_HasValue, DecimalInput, DecimalInput__get_Value, DecimalInput__get_ErrorMessage, Editable$2, DecimalInput_$reflection } from "../Input.jsx";
import { Ausdruck, AusdruckModule_ofDecimal } from "../Ausdruck.jsx";
import { TaskResultMsgModule_fail, TaskResultMsgModule_success, TaskResultMsgModule_updateState, TaskResultMsgModule_finish } from "../Types.jsx";

export class Einheit extends Record {
    constructor(Name, Faktor) {
        super();
        this.Name = Name;
        this.Faktor = (Faktor | 0);
    }
}

export function Einheit_$reflection() {
    return record_type("MatheApp.Domain.Konvertieren.Einheit", [], Einheit, () => [["Name", string_type], ["Faktor", int32_type]]);
}

export const dezimalEinheiten = ofArray([new Einheit("", 0), new Einheit("%", -2)]);

export const laengeEinheiten = ofArray([new Einheit("km", 3), new Einheit("m", 0), new Einheit("dm", -1), new Einheit("cm", -2), new Einheit("mm", -3)]);

export const volumenEinheiten = ofArray([new Einheit("m³", 3), new Einheit("l", 0), new Einheit("dm³", 0), new Einheit("ml", -3), new Einheit("cm³", -3)]);

export const flaechenEinheiten = ofArray([new Einheit("km²", 6), new Einheit("ha", 4), new Einheit("a", 2), new Einheit("m²", 0), new Einheit("dm²", -2), new Einheit("cm²", -4), new Einheit("mm²", -6)]);

export const masseEinheiten = ofArray([new Einheit("t", 6), new Einheit("kg", 3), new Einheit("g", 0), new Einheit("mg", -3)]);

export const einheitenKategorien = ofArray([dezimalEinheiten, laengeEinheiten, volumenEinheiten, flaechenEinheiten, masseEinheiten]);

export function getEinheit(name) {
    return find((e) => (e.Name === name), collect((x) => x, einheitenKategorien));
}

export function generateRandomTask(random) {
    const totalDigits = random.Next2(1, 10) | 0;
    const decimalPlaces = random.Next2(0, totalDigits + 1) | 0;
    const integerDigits = (totalDigits - decimalPlaces) | 0;
    const digits = toArray(delay(() => collect_1((i) => (((i === 0) && (integerDigits > 0)) ? singleton(random.Next2(1, 10)) : singleton(random.Next2(0, 10))), rangeDouble(0, 1, totalDigits - 1))));
    const integerPart = join("", map(int32ToString, digits.slice(0, (integerDigits - 1) + 1)));
    const dezimal = Decimal_Normalize_32C73145(parse((decimalPlaces === 0) ? integerPart : concat(integerPart, ".", ...join("", map(int32ToString, digits.slice(integerDigits, digits.length))))));
    const chooseUnits = () => {
        const kategorie = item(random.Next1(length(einheitenKategorien)), einheitenKategorien);
        if (length(kategorie) < 2) {
            return chooseUnits();
        }
        else {
            const startUnit = item(random.Next1(length(kategorie)), kategorie);
            let zielUnit = item(random.Next1(length(kategorie)), kategorie);
            while (zielUnit.Name === startUnit.Name) {
                zielUnit = item(random.Next1(length(kategorie)), kategorie);
            }
            const faktorDiff = (startUnit.Faktor - zielUnit.Faktor) | 0;
            if (Decimal_Length_32C73145(op_Multiply(dezimal, new Decimal(Math.pow(10, faktorDiff)))) <= 9) {
                return [startUnit.Name, zielUnit.Name];
            }
            else {
                return chooseUnits();
            }
        }
    };
    const patternInput = chooseUnits();
    return [dezimal, patternInput[0], patternInput[1]];
}

export class VerschiebungsState extends Record {
    constructor(OriginalDezimal, StartEinheit, ZielEinheit, Dezimal) {
        super();
        this.OriginalDezimal = OriginalDezimal;
        this.StartEinheit = StartEinheit;
        this.ZielEinheit = ZielEinheit;
        this.Dezimal = Dezimal;
    }
}

export function VerschiebungsState_$reflection() {
    return record_type("MatheApp.Domain.Konvertieren.VerschiebungsState", [], VerschiebungsState, () => [["OriginalDezimal", decimal_type], ["StartEinheit", string_type], ["ZielEinheit", string_type], ["Dezimal", DecimalInput_$reflection()]]);
}

export class AbgeschlossenState extends Record {
    constructor(OriginalDezimal, StartEinheit, ZielEinheit, Ergebnis) {
        super();
        this.OriginalDezimal = OriginalDezimal;
        this.StartEinheit = StartEinheit;
        this.ZielEinheit = ZielEinheit;
        this.Ergebnis = Ergebnis;
    }
}

export function AbgeschlossenState_$reflection() {
    return record_type("MatheApp.Domain.Konvertieren.AbgeschlossenState", [], AbgeschlossenState, () => [["OriginalDezimal", decimal_type], ["StartEinheit", string_type], ["ZielEinheit", string_type], ["Ergebnis", decimal_type]]);
}

export class State extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["VerschiebungsState", "AbgeschlossenState"];
    }
}

export function State_$reflection() {
    return union_type("MatheApp.Domain.Konvertieren.State", [], State, () => [[["Item", VerschiebungsState_$reflection()]], [["Item", AbgeschlossenState_$reflection()]]]);
}

export function State__get_OriginalDezimal(this$) {
    if (this$.tag === 1) {
        return this$.fields[0].OriginalDezimal;
    }
    else {
        return this$.fields[0].OriginalDezimal;
    }
}

export function State__get_StartEinheit(this$) {
    if (this$.tag === 1) {
        return this$.fields[0].StartEinheit;
    }
    else {
        return this$.fields[0].StartEinheit;
    }
}

export function State__get_ZielEinheit(this$) {
    if (this$.tag === 1) {
        return this$.fields[0].ZielEinheit;
    }
    else {
        return this$.fields[0].ZielEinheit;
    }
}

export function State__get_Ergebnis(this$) {
    if (this$.tag === 1) {
        return new Editable$2(1, [this$.fields[0].Ergebnis]);
    }
    else {
        return new Editable$2(2, [this$.fields[0].Dezimal]);
    }
}

export function State__get_Rückmeldung(this$) {
    if (this$.tag === 1) {
        return "Richtig!";
    }
    else {
        return DecimalInput__get_ErrorMessage(this$.fields[0].Dezimal);
    }
}

export function State__get_Format(this$) {
    return new Ausdruck(9, [ofArray([new Ausdruck(8, [AusdruckModule_ofDecimal(State__get_OriginalDezimal(this$)), State__get_StartEinheit(this$)]), new Ausdruck(6, [new Ausdruck(0, []), new Ausdruck(8, [State__get_Ergebnis(this$).Ausdruck, State__get_ZielEinheit(this$)])])])]);
}

export function State__get_CanKommaLinks(this$) {
    if (this$.tag === 0) {
        return Decimal_Length_32C73145(op_Division(DecimalInput__get_Value(this$.fields[0].Dezimal), fromParts(10, 0, 0, false, 0))) <= 9;
    }
    else {
        return false;
    }
}

export function State__get_CanKommaRechts(this$) {
    if (this$.tag === 0) {
        return Decimal_Length_32C73145(op_Multiply(DecimalInput__get_Value(this$.fields[0].Dezimal), fromParts(10, 0, 0, false, 0))) <= 9;
    }
    else {
        return false;
    }
}

export const initialState = new State(0, [new VerschiebungsState(fromParts(0, 0, 0, false, 1), "m", "km", new DecimalInput(0, [""]))]);

export function create(random) {
    const patternInput = generateRandomTask(random);
    const dezimal = patternInput[0];
    return new State(0, [new VerschiebungsState(dezimal, patternInput[1], patternInput[2], new DecimalInput(0, [Decimal_Format_32C73145(dezimal)]))]);
}

export class Msg extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["KommaLinks", "KommaRechts", "Ok"];
    }
}

export function Msg_$reflection() {
    return union_type("MatheApp.Domain.Konvertieren.Msg", [], Msg, () => [[], [], []]);
}

export function reduce(logger, state, action) {
    let inputRecord_1, inputRecord_2, inputRecord;
    logger(toText(interpolate("Reducing state: %A%P() with action: %A%P()", [state, action])));
    if (state.tag === 1) {
        if (action.tag === 2) {
            return TaskResultMsgModule_finish(state);
        }
        else {
            return TaskResultMsgModule_updateState(state);
        }
    }
    else {
        switch (action.tag) {
            case 0:
                if (State__get_CanKommaLinks(state)) {
                    return TaskResultMsgModule_updateState(new State(0, [(inputRecord_1 = state.fields[0], new VerschiebungsState(inputRecord_1.OriginalDezimal, inputRecord_1.StartEinheit, inputRecord_1.ZielEinheit, new DecimalInput(0, [Decimal_Format_32C73145(op_Division(DecimalInput__get_Value(state.fields[0].Dezimal), fromParts(10, 0, 0, false, 0)))])))]));
                }
                else {
                    return TaskResultMsgModule_updateState(state);
                }
            case 1:
                if (State__get_CanKommaRechts(state)) {
                    return TaskResultMsgModule_updateState(new State(0, [(inputRecord_2 = state.fields[0], new VerschiebungsState(inputRecord_2.OriginalDezimal, inputRecord_2.StartEinheit, inputRecord_2.ZielEinheit, new DecimalInput(0, [Decimal_Format_32C73145(Decimal_Normalize_32C73145(op_Multiply(DecimalInput__get_Value(state.fields[0].Dezimal), fromParts(10, 0, 0, false, 0))))])))]));
                }
                else {
                    return TaskResultMsgModule_updateState(state);
                }
            default:
                if (DecimalInput__get_HasValue(state.fields[0].Dezimal)) {
                    let expected;
                    const faktorDiff = (getEinheit(state.fields[0].StartEinheit).Faktor - getEinheit(state.fields[0].ZielEinheit).Faktor) | 0;
                    expected = op_Multiply(state.fields[0].OriginalDezimal, new Decimal(Math.pow(10, faktorDiff)));
                    if (equals(DecimalInput__get_Value(state.fields[0].Dezimal), expected)) {
                        return TaskResultMsgModule_success(new State(1, [new AbgeschlossenState(state.fields[0].OriginalDezimal, state.fields[0].StartEinheit, state.fields[0].ZielEinheit, expected)]));
                    }
                    else {
                        return TaskResultMsgModule_fail(new State(0, [(inputRecord = state.fields[0], new VerschiebungsState(inputRecord.OriginalDezimal, inputRecord.StartEinheit, inputRecord.ZielEinheit, DecimalInput_Error_6B54009B(expected, DecimalInput__get_Value(state.fields[0].Dezimal), "Falsch")))]));
                    }
                }
                else {
                    return TaskResultMsgModule_updateState(state);
                }
        }
    }
}

